import {useCallback, useMemo} from 'react';
import {Location, useLocation} from 'react-router';
import {PostLoginState} from '../types';
import {usePostLoginSessionState} from './usePostLoginSessionState';

interface UsePostLoginState {
  clearPostLoginState: () => void;
  postLoginState: PostLoginState;
  persistPostLoginState: () => void;
}

export function usePostLoginState(): UsePostLoginState {
  const location = useLocation();
  const stableLocation = JSON.stringify(location); // location is not stable (and will cause unnecessary re-renders), but the serialized version is safe
  const [, setPostLoginState] = usePostLoginSessionState();
  const postLoginState: PostLoginState = useMemo(
    () => ({
      postLoginLocation: JSON.parse(stableLocation) as Location,
    }),
    [stableLocation],
  );
  const clearPostLoginState = useCallback(() => setPostLoginState(null), [setPostLoginState]);
  const persistPostLoginState = useCallback(
    () => setPostLoginState(postLoginState),
    [postLoginState, setPostLoginState],
  );
  return {clearPostLoginState, persistPostLoginState, postLoginState};
}
